import React from "react";
import { Church, Droplets, MapPinned, UserRound, Users } from "lucide-react";
import HeroStat from "@/components/shared/HeroStat";

export function DistrictHero({ districtName, districtField, loading, summary, summaryLoading }) {
  return (
    <div className="px-3 pt-4 sm:px-4">
      <div
        className="relative overflow-hidden bg-gradient-to-br from-[#1c1b2e] via-[#24223a] to-[#2d2b47] rounded-[28px] p-5 shadow-[0_4px_20px_rgba(28,27,46,0.18)] dark:shadow-none"
        style={{ WebkitMaskImage: "-webkit-radial-gradient(white, black)" }}
      >
        <div className="absolute inset-0 rounded-[inherit] bg-gradient-to-br from-white/[0.05] to-transparent pointer-events-none" />
        <div className="absolute inset-0 rounded-[inherit] overflow-hidden pointer-events-none">
          <div className="absolute -top-12 -right-12 h-40 w-40 rounded-full bg-violet-400/10 blur-2xl" />
        </div>

        {/* District identity */}
        <div className="relative z-10 flex items-center gap-3">
          <div className="h-11 w-11 rounded-[14px] bg-white/10 border border-white/10 flex items-center justify-center shrink-0">
            <MapPinned size={20} className="text-white/80" strokeWidth={2} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-widest text-white/55 font-medium truncate">
              {districtField || "Panorama distrital"}
            </p>
            {loading ? (
              <div className="mt-1">
                <div className="h-5 w-36 bg-white/10 rounded-lg animate-pulse" />
              </div>
            ) : (
              <h2 className="text-[18px] font-semibold text-white/95 leading-tight truncate mt-0.5">
                {districtName || "Distrito"}
              </h2>
            )}
          </div>
        </div>

        {/* Stats — 4 columns matching ChurchDetail HeroStat pattern */}
        <div className="relative z-10 grid grid-cols-4 gap-2 mt-4">
          {summaryLoading ? (
            [0, 1, 2, 3].map((i) => (
              <div
                key={i}
                className="rounded-[16px] border border-white/10 bg-white/[0.08] p-2 flex flex-col items-center gap-1.5 animate-pulse"
              >
                <div className="h-6 w-6 rounded-[10px] bg-white/10" />
                <div className="h-3 w-8 rounded bg-white/10" />
                <div className="h-2 w-10 rounded bg-white/10" />
              </div>
            ))
          ) : (
            <>
              <HeroStat icon={Church}    value={summary?.churchCount       ?? "—"} label="Iglesias"  />
              <HeroStat icon={Users}     value={summary?.totalFamilies     ?? "—"} label="Hogares"   />
              <HeroStat icon={UserRound} value={summary?.totalPersons      ?? "—"} label="Personas"  />
              <HeroStat icon={Droplets}  value={summary?.baptismsThisYear  ?? "—"} label="Bautismos" />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
